import styled from "styled-components";
import { Card } from "react-bootstrap";

export const StyledSection = styled.section`
  padding-bottom: 5rem;
  width: 60%;
  
  @media screen and (max-width: 1700px) {
    width: 70%;
  }
  @media screen and (max-width: 1400px) {
    width: auto;
  }
  
`;

export const CardContent = styled(Card)`
  width: 320px;
  height: 385px;
  border: 1px solid var(--light-color);
  border-radius: 6px;
  background: var( --white-color);
  transition: all ease 0.5s;

  &:hover {
    border-top: 3px solid var(--tertiary-color);
    box-shadow: var(--box-shadow3);
  }

  @media screen and (max-width: 1200px) {
    width: 300px;
  }
  @media screen and (max-width: 992px) {
    width: 320px;
  }
  @media screen and (max-width: 320px) {
    width: 290px;
  }
  .icon-background {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export const Title = styled.h3`
  font-weight: 500;
  font-size: var(--font-size-lg);
  color: var(--field-color);
`;
export const SubTitle = styled.h4`
  font-weight: 500;
  font-size: var(--font-size-sm);
  color: var(--text-color-dark);
`;
export const Caption = styled.p`
  font-weight: 400;
  font-size: var(--font-size-sm);
  color: var(--text-color-muted);
  a {
    color: var(--text-color-muted);
  }
`;
